import { primaryAddress } from "@productlane/lib/src/email-settings"

import { useZeroWorkspace } from "@/lib/zero"
import { BlockedEmailAddressesCard } from "./blocked-email-addresses-card"
import { ForwardedEmailHandlingCard } from "./forwarded-email-handling-card"
import { EmailSetupSteps } from "./setup-steps/setup-steps"
import { SupportAddressesCard } from "./support-addresses-card"

export function EmailInboxSettingsContent() {
	const workspace = useZeroWorkspace()

	if (!workspace) return null

	const primary = primaryAddress(workspace.emailSettings)

	if (primary?.isEnabled && primary.primaryEmail) {
		return (
			<div className="flex flex-col gap-4">
				<SupportAddressesCard workspace={workspace} />
				<BlockedEmailAddressesCard />
				<ForwardedEmailHandlingCard />
			</div>
		)
	}

	return <EmailSetupSteps workspace={workspace} />
}
